import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiManagersKpiTermsEditType } from "~/domains";

type ParamsType = {
  id: string;
};

const request = async ({
  id,
}: ParamsType): Promise<ApiManagersKpiTermsEditType> => {
  const response = await new ApiClient().get<ApiManagersKpiTermsEditType>(
    `/api/managers/kpi_terms/${id}/edit`,
  );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersKpiTermsEdit = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiManagersKpiTermsEditType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersKpiTermsEdit", id],
    cacheTime: 0,
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
